// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".byTip[data-v-7222bb1c]{display:-webkit-box;display:-ms-flexbox;display:flex;width:var(--width);height:var(--height);background:var(--background-def);border-radius:4px;font-size:var(--font-size);font-family:PingFangSC,PingFang SC;font-weight:400;color:var(--color);padding:8px;text-align:var(--text-align-def)}.byTip i[data-v-7222bb1c]{margin-right:8px}", ""]);
// Exports
module.exports = exports;
